import axios from 'axios';

const baseUrl = process.env.REACT_APP_QCX_API_BASE_URL! + '/movimentacao/report/proforma-packing-list-saida';

const generateSpreadsheetProformaPackingListSaida = async (
  token: string,
  unidadeId: number,
  clientesIds: number[] = [],
  exportadoresIds: number[] = [],
  processosNumeros: string[] = [],
  dataInicio?: string,
  dataFim?: string
) => {
  const params = new URLSearchParams();
  if (clientesIds.length > 0) {
    params.set('clientesId', clientesIds.join(','));
  }
  if (exportadoresIds.length > 0) {
    params.set('exportadoresId', exportadoresIds.join(','));
  }
  processosNumeros.forEach((numero) => {
    params.append('processos', numero);
  });
  if (dataInicio) {
    params.set('inicio', dataInicio);
  }
  if (dataFim) {
    params.set('fim', dataFim);
  }

  const query = params.toString();
  const url = query ? `${baseUrl}?${query}` : baseUrl;

  let message = null;

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
    });

    if (response.status === 200) {
      const file = new File([response.data], 'relatorioProformaPackingListSaida.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const objectUrl = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = file.name;
      a.click();
    } else {
      message = await response.data.text();
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response && error.response.data) {
        message = await error.response.data.text();
      } else {
        message = 'Erro inesperado';
      }
    } else {
      message = 'Erro inesperado';
    }
  }
  return message;
};

export { generateSpreadsheetProformaPackingListSaida };
